import axios from "axios";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form"];

  confirmBack(event) {
    event.preventDefault();
    const redirectUrl = this.data.get("redirect-url");

    window.parent.location = redirectUrl;
  }

  confirmPayNow(event) {
    event.preventDefault();
    const url = this.data.get("url"),
      redirectUrl = this.data.get("redirect-url");

    $(".confirm-payment-detail .btn").prop("disabled", true);
    $(".confirm-payment-detail").hide();
    $(".payment-details-container").show();

    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw response;
        }
        return response.text();
      })
      .then(html => {
        document.querySelector(".payment-result-place-holder").innerHTML = html;

        $("#payment-result-modal").on("shown.bs.modal", function (e) {
          console.log("testing .....");
          $(".modal-backdrop").removeClass("show");
        });

        $("#payment-result-modal").modal({
          show: true,
          backdrop: "static",
          keyboard: false
        });
        $(".spinner-container").hide();
      })
      .catch(error => {
        hideModal("#payment-result-modal");
        bootbox.alert({
          message:
            "There is an error while processing your payment, please make sure you entered correct payment details.",
          callback: function () {
            window.parent.location = redirectUrl;
          },
          closeButton: false
        });
      });
  }
}
